/* ===========================================================
   키즈다 뉴스 — 1차 카테고리(뉴스 주제) 목록 API (newsCategoryTopicList)

   카테고리 개편(2026-08): 웹은 1차(네이버 표준 6종)만 노출한다 (BR-09).
   2차(키즈다 카테고리)는 앱 전용 — 웹에서는 조회·표기하지 않는다.
   newsCategoryTopicList 는 permitAll · 인자 없음.
   =========================================================== */
import graphqlClient from "../../utils/graphql_client_util";

const NEWS_TOPIC_LIST_QUERY = `
  query NewsCategoryTopicList {
    newsCategoryTopicList {
      success
      error {
        code
        errorType
        message
      }
      data {
        topicCategorySeq
        code
        title
        displayOrder
      }
    }
  }
`;

/* 1차 카테고리 고정 색상 — news_topic_category 에는 color 컬럼이 없다.
   1차 6종은 네이버 합의값(명칭·구성 변경 금지, 잠금)이라 타이틀 키가 안정적. */
const TOPIC_COLORS = {
  "사회": "#5F3AD1",
  "생활/문화": "#FF7520",
  "IT/과학": "#0693DA",
  "경제": "#07A66E",
  "세계": "#F03F71",
  "정치": "#0D6CF9",
};

export const topicColorOf = (title) => TOPIC_COLORS[title] || "#155dfc";

/**
 * 1차 카테고리(뉴스 주제) 목록 조회 → 메뉴 컴포넌트용 형태로 변환
 * 반환: [{ key, name, color, order, image }] (displayOrder 오름차순) | null(실패)
 * - key = String(topicCategorySeq) — 뉴스 필터(topicCategorySeq)에 그대로 사용
 * - image: 1차는 이미지가 없다 → null (메뉴는 이미지 없이 렌더)
 */
export const getNewsCategoryList = async () => {
  try {
    const data = await graphqlClient.query(
      NEWS_TOPIC_LIST_QUERY,
      {},
      { useAuth: false }
    );

    const res = data?.newsCategoryTopicList;
    if (res?.success && Array.isArray(res.data) && res.data.length) {
      return [...res.data]
        .sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0))
        .map((t) => ({
          key: String(t.topicCategorySeq),
          name: t.title,
          color: topicColorOf(t.title),
          order: t.displayOrder,
          image: null,
        }));
    }
    return null;
  } catch (err) {
    console.error("getNewsCategoryList error:", err);
    return null;
  }
};
